import { render, staticRenderFns } from "./AddSurveyQuestion.vue?vue&type=template&id=a9f3411a&scoped=true"
import script from "./AddSurveyQuestion.vue?vue&type=script&lang=ts"
export * from "./AddSurveyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./AddSurveyQuestion.vue?vue&type=style&index=0&id=a9f3411a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f3411a",
  null
  
)

export default component.exports